import React, { useEffect, useState } from 'react';

import styles from './register-page.module.scss';
import Navbar from '../../components/navbar/Navbar';
import DevForm from '../../components/register-forms/developer-register-form/DeveloperRegForm';
import CompForm from '../../components/register-forms/company-register-form/CompanyRegForm';

const RegisterPage = () => {
  //Register page states
  const [userInfo, setUserInfo] = useState({});
  const [choice, setChoice] = useState('');

  //Register component states
  const [isDevHovered, setIsDevHovered] = useState(false);
  const [isCompHovered, setIsCompHovered] = useState(false);
  const [isDev, setIsDev] = useState(false);
  const [isComp, setIsComp] = useState(false);

  useEffect(() => {
    console.log(userInfo);
  }, [userInfo]);

  const devBtnHandle = () => {
    setUserInfo({ role: choice });
  };

  const companyBtnHandle = () => {
    setUserInfo({ role: choice });
  };

  if (userInfo.role === 'developer') {
    return (
      <>
        <Navbar />
        <section className={styles.registerWrapper}>
          <DevForm user={userInfo} />
        </section>
      </>
    );
  } else if (userInfo.role === 'company') {
    return (
      <>
        <Navbar />
        <section className={styles.registerWrapper}>
          <CompForm user={userInfo} />
        </section>
      </>
    );
  }
  return (
    <>
      <Navbar />
      <section className={styles.registerWrapper}>
        <section className={styles.regOne}>
          <div
            className={styles.regOne_left}
            onMouseEnter={() => {
              setIsDevHovered(true);
            }}
            onMouseLeave={() => {
              setIsDevHovered(false);
            }}
            onClick={() => {
              setChoice('developer');
              setIsDev(true);
              setIsComp(false);
            }}
          >
            <h3
              className={`${styles.devText} ${
                isDevHovered ? styles.active : ''
              }`}
            >
              I am a developer
            </h3>
            <button
              className={`${styles.btn} ${isDev ? styles.active : ''}`}
              onClick={() => {
                devBtnHandle();
              }}
            >
              Next
            </button>
          </div>
          <div
            className={styles.regOne_right}
            onMouseEnter={() => {
              setIsCompHovered(true);
            }}
            onMouseLeave={() => {
              setIsCompHovered(false);
            }}
            onClick={() => {
              setChoice('company');
              setIsComp(true);
              setIsDev(false);
            }}
          >
            <h3
              className={`${styles.compText} ${
                isCompHovered ? styles.active : ''
              }`}
            >
              I want to hire
            </h3>
            <button
              className={`${styles.btn} ${isComp ? styles.active : ''}`}
              onClick={() => {
                companyBtnHandle();
              }}
            >
              Next
            </button>
          </div>
        </section>
      </section>
    </>
  );
};

export default RegisterPage;
